import { Header } from "@/components/Header";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowRight, FileSpreadsheet } from "lucide-react";
import Footer from "@/components/Footer";
import macrosPreview from "@/assets/macros-preview.png";
import { GrowingLibrarySection } from "@/components/GrowingLibrarySection";
import { MacroShowcaseSection } from "@/components/MacroShowcaseSection";
import { WhatWeDoSection } from "@/components/WhatWeDoSection";
import { CodeShowcaseSection } from "@/components/CodeShowcaseSection";
import { useTheme } from "next-themes";
import { useEffect } from "react";
const Index = () => {
  const navigate = useNavigate();
  const {
    setTheme
  } = useTheme();
  useEffect(() => {
    setTheme("light");
  }, [setTheme]);
  return <div className="min-h-screen bg-background">
      <Helmet>
        <title>MacroVault - Discover Powerful Excel VBA Macros</title>
        <meta name="description" content="Featuring professionally-verified VBA macros for Excel automation. New macros added daily." />
        <link rel="canonical" href="https://findmacros.com/" />
      </Helmet>
      <Header variant="landing" />

      <main>
        {/* Hero Section */}
        <section className="pt-20 md:pt-32 pb-12 md:pb-16">
          <div className="container mx-auto px-4 max-w-5xl">
            <div className="text-center space-y-8">
              {/* Icon */}
              

              {/* Headline */}
              <h1 className="text-5xl md:text-7xl font-bold tracking-tight leading-tight mt-6 md:mt-0">
                Discover powerful
                <br />
                Excel macros.
              </h1>

              {/* Subtitle */}
              <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
                Featuring professionally-verified VBA macros for Excel automation. New macros added daily.
                <br />
              </p>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
                <Button size="lg" onClick={() => navigate("/vault")} className="rounded-full px-8 h-14 text-base font-medium bg-green-700 hover:bg-green-600">
                  Browse for free  
                  <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                </Button>
                <Button size="lg" variant="outline" className="rounded-full px-8 h-14 text-base font-medium" onClick={() => navigate("/auth")}>
                  Sign in / Create account
                </Button>
              </div>

              {/* Trusted By Section */}
            </div>
          </div>
        </section>

        {/* Preview Section */}
        

        {/* Macro Showcase Section */}
        <MacroShowcaseSection />

        {/* Growing Library Section */}
        <GrowingLibrarySection />

        {/* What We Do Section */}
        <WhatWeDoSection />

        {/* Code Showcase Section */}
        <CodeShowcaseSection />
      </main>

      <Footer />
    </div>;
};
export default Index;